/* eslint-disable */
import { Button, notification, Skeleton, Tabs } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Banner from "../components/Banner";
import AWB from "../components/checkout/AWB";
import InvoiceInfo from "../components/checkout/InvoiceInfo";
import TabEInvoice from "../components/checkout/TabEInvoice";
import TabReceiverInfo from "../components/checkout/TabReceiverInfo";
import { getOrderObj, logoutCheckin } from "../config/checkinApi";
import "./page-css/Checkout.css";
import {
  IMP_WEB_CHK_LOAD,
  IMP_WEB_CHK_LOAD_BIL_CHG_OBJ,
  IMP_WEB_CHK_GET_AWB_DTL,
  IMP_WEB_CHK_PAID_ALL_INVOICE,
} from "../config/apiConfig";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";
import { getMerchantData, checkPaymentSuccess } from "../config/checkinApi";
import { useDispatch } from "react-redux";
import { checkinUser } from "../actions/userAWB";
import { setPaymentInfo } from "./../actions/payment";
import { userAwbLogout } from "./../actions/userAWB";
import { useTranslation } from "react-i18next";
import TabVehicle from "../components/checkout/TabVehicleRegistration";
import moment from "moment";
const { TabPane } = Tabs;

const Checkout = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const [activeKey, setActiveKey] = useState();
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState();
  const [invoiceInfo, setInvoiceInfo] = useState();
  const [chargeInfo, setChargeInfo] = useState();
  const [billChargeInfo, setBillChargeInfo] = useState();
  const [invoiceList, setInvoiceList] = useState();
  const [paymentDetails, setPaymentDetails] = useState();
  const [isInfoCreated, setIsInfoCreated] = useState(false);
  const [awbDetail, setAwbDetail] = useState();
  const [status, setStatus] = useState("NY");

  const { token } = JSON.parse(localStorage.getItem("checkin"));
  const { MAWB } = useSelector((state) => state.mawb);
  const pInfo = JSON.parse(localStorage.getItem("pInfo"));

  const history = useHistory();
  const location = useLocation();

  const handleLogoutCheckin = async () => {
    await logoutCheckin(token);
    dispatch(checkinUser({}));
    dispatch(setPaymentInfo(undefined));
    dispatch(userAwbLogout());
    localStorage.removeItem("userAWB");
    localStorage.removeItem("checkin");
    localStorage.removeItem("pInfo");
    history.push("/");
    notification.success({
      message: "Đăng xuất thành công!",
      style: { marginRight: "-50%" },
    });
  };

  const loadData = async () => {
    try {
      setLoading(true);
      let loadRes = await IMP_WEB_CHK_LOAD(
        {
          COD_AWB_PFX: MAWB.first,
          COD_AWB_NUM: MAWB.last,
          COD_AWB_SFX: MAWB.suffix,
          COD_HWB_NUM: MAWB.hawb,
        },
        token
      );
      const params = queryString.parse(location.search);
      if (Object.keys(params).length !== 0) {
        const dataDecoded = await getMerchantData(params.napasResult, token);
        if (dataDecoded.data.paymentResult.result === "SUCCESS") {
          const isSuccessRes = await checkPaymentSuccess(
            dataDecoded.data.paymentResult.order.id,
            token
          );
          const { transaction, order } = dataDecoded.data.paymentResult;
          const orderObjRes = await getOrderObj(order.id, token);
          if (orderObjRes.data) {
            if (
              isSuccessRes.data.status === true &&
              parseInt(orderObjRes.data.tableID) ===
                loadRes.data.mCol[0].TABLE_ID &&
              orderObjRes.data.orderID ===
                loadRes.data.mCol[0].RCV_BNK_TRS_CD1 &&
              orderObjRes.data.amount == loadRes.data.mCol[0].AMT_CSH_INV &&
              orderObjRes.data.orderReference ===
                loadRes.data.mCol[0].SND_PAY_STR
            ) {
              await IMP_WEB_CHK_PAID_ALL_INVOICE(
                {
                  ...loadRes.data.mCol[0],
                  RCV_DAT:
                    transaction.acquirer.date ??
                    moment().format("YYYY/MM/DD HH:mm:ss"),
                  RCV_BNK_AMT: transaction.amount,
                  RCV_BNK_TRS_COD: transaction.acquirer.transactionId,
                  COD_CUR: transaction.currency,
                  RCV_BNK_STR: `${
                    transaction.acquirer.date ??
                    moment().format("YYYY/MM/DD HH:mm:ss")
                  }#${transaction.acquirer.id ?? ""}#${
                    transaction.acquirer.transactionId ?? ""
                  }#${transaction.amount}#${transaction.currency}#${
                    transaction.id
                  }#${transaction.type}#`,
                  /* SND_PAY_STR: `${order.amount}#${order.creationTime}#${order.currency}#${order.id}#`, */
                  SND_PAY_DAT: order.creationTime,
                  BNK_COD: `${order.id}#${pInfo.order.id}#`,
                  RCV_BNK_TRS_CD1: loadRes.data.mCol[0].RCV_BNK_TRS_CD1
                    ? loadRes.data.mCol[0].RCV_BNK_TRS_CD1
                    : orderObjRes.data.orderID,
                },
                token
              );
              loadRes = await IMP_WEB_CHK_LOAD(
                {
                  COD_AWB_PFX: MAWB.first,
                  COD_AWB_NUM: MAWB.last,
                  COD_AWB_SFX: MAWB.suffix,
                  COD_HWB_NUM: MAWB.hawb,
                },
                token
              );
              notification.success({
                style: { marginRight: "-50%" },
                message:
                  /* dataDecoded.data.paymentResult.response.message */ "Đã hoàn tất làm thủ tục cho lô hàng này!",
              });
              setTimeout(() => history.push("/awb/checkout"), 1000);
            } else {
              notification.error({
                message:
                  "Không nhận được thông tin phản hồi từ ngân hàng, hãy kiểm tra lại thông tin về giao dịch trên tài khoản của bạn và liên hệ với bộ phận Tin học của công ty TCS nếu cần.",
                style: { marginRight: "-50%" },
              });
              setTimeout(() => history.push("/awb/checkout"), 1000);
            }
          } else {
            notification.error({
              message:
                "Không nhận được thông tin phản hồi từ ngân hàng, hãy kiểm tra lại thông tin về giao dịch trên tài khoản của bạn và liên hệ với bộ phận Tin học của công ty TCS nếu cần.",
              style: { marginRight: "-50%" },
            });
            setTimeout(() => history.push("/awb/checkout"), 1000);
          }
        } else {
          notification.error({
            message:
              "Không nhận được thông tin phản hồi từ ngân hàng, hãy kiểm tra lại thông tin về giao dịch trên tài khoản của bạn và liên hệ với bộ phận Tin học của công ty TCS nếu cần.",
            style: { marginRight: "-50%" },
          });
          setTimeout(() => history.push("/awb/checkout"), 1000);
        }
      }
      const getAwbDetailRes = await IMP_WEB_CHK_GET_AWB_DTL(
        {
          COD_AWB_PFX: MAWB.first,
          COD_AWB_NUM: MAWB.last,
          COD_AWB_SFX: MAWB.suffix,
          COD_HWB_NUM: MAWB.hawb,
        },
        token
      );
      setAwbDetail(getAwbDetailRes.data.mCol[0]);
      if (loadRes.data !== null) {
        if (loadRes.data.mCol.length === 0) {
          notification.info({
            message: "Chưa đăng kí thông tin người nhận",
            style: { marginRight: "-50%" },
          });
          setIsInfoCreated(false);
        } else if (loadRes.data.mCol[0].TABLE_ID !== 0) {
          const { COD_STS } = loadRes.data.mCol[0];
          setInfo(loadRes.data.mCol[0]);
          if (COD_STS !== "NY") {
            try {
              const loadBillChargeRes = await IMP_WEB_CHK_LOAD_BIL_CHG_OBJ(
                loadRes.data.mCol[0],
                token
              );
              if (COD_STS !== "AQ")
                setChargeInfo(
                  loadBillChargeRes.data.P_RET_IMP_WEB_BIL_CHG_COLL.mCol
                );
              setInvoiceInfo(
                loadBillChargeRes.data.P_RET_IMP_WEB_BIL_INV_COLL.mCol
              );
              setBillChargeInfo(loadBillChargeRes.data.P_RET_BIL_CHG_COLL.mCol);
              setInvoiceList(loadBillChargeRes.data.P_RET_BIL_INV_COLL.mCol);
              setPaymentDetails(
                loadBillChargeRes.data.P_RET_BIL_INV_PMT_COLL.mCol
              );
              setIsInfoCreated(true);
              setStatus(COD_STS);
            } catch (err) {
              console.log(err);
              notification.error({
                style: { marginRight: "-50%" },
                message:
                  "Không nhận được thông tin phản hồi từ ngân hàng, hãy kiểm tra lại thông tin về giao dịch trên tài khoản của bạn, đăng nhập và thử lại hoặc liên hệ với bộ phận Tin học của công ty TCS nếu cần.",
              });
            }
          } else {
            setIsInfoCreated(false);
          }
        }
      } else {
        setIsInfoCreated(false);
      }
    } catch (err) {
      console.log(err);
      if (err.response && err.response.status === 401) {
        notification.error({
          style: { marginRight: "-50%" },
          message: t("home.sessionNoti"),
        });

        dispatch(checkinUser({}));
        dispatch(setPaymentInfo(undefined));
        dispatch(userAwbLogout());
        localStorage.removeItem("userAWB");
        localStorage.removeItem("checkin");
        localStorage.removeItem("pInfo");
        history.push("/");
      } else
        notification.error({
          style: { marginRight: "-50%" },
          message:
            "Không nhận được thông tin phản hồi từ ngân hàng, hãy kiểm tra lại thông tin về giao dịch trên tài khoản của bạn, đăng nhập và thử lại hoặc liên hệ với bộ phận Tin học của công ty TCS nếu cần.",
        });
    } finally {
      setLoading(false);
    }
  };
  const operations = (
    <Button
      className="exit-btn"
      onClick={() => handleLogoutCheckin()}
      style={{ width: "fit-content" }}
    >
      {t("header.logOut")}
    </Button>
  );
  useEffect(() => {
    loadData();
  }, []);
  return (
    <>
      <Banner
        title={""}
        className="banner-wrapper"
        cover={"../../img/004.jpg"}
      />
      <Skeleton loading={loading} active={loading}>
        <div className="checkout-content-wrapper">
          <div className="checkout-content">
            <Tabs
              className="tab-checkout"
              activeKey={activeKey}
              onChange={(key) => setActiveKey(key)}
              defaultActiveKey={"receiver-info"}
              size={"default"}
              tabBarExtraContent={operations}
            >
              <TabPane tab={"receiver info"} key={"receiver-info"}>
                <TabReceiverInfo
                  status={status}
                  isInfoCreated={isInfoCreated}
                  awbDetail={awbDetail}
                  loadData={loadData}
                  info={info}
                  setActiveKey={setActiveKey}
                  className="form-receiver"
                />
              </TabPane>
              <TabPane disabled={status === "NY"} tab={"AWB"} key={"awb"}>
                <AWB
                  status={status}
                  loadData={loadData}
                  awbDetail={awbDetail}
                  info={info}
                  chargeInfo={chargeInfo}
                  setActiveKey={setActiveKey}
                />
              </TabPane>
              <TabPane
                disabled={status === "NY" || status === "AQ"}
                tab={"invoice info"}
                key={"invoice-info"}
              >
                <InvoiceInfo
                  info={info}
                  status={status}
                  loadData={loadData}
                  invoiceInfo={invoiceInfo}
                  chargeInfo={chargeInfo}
                  setActiveKey={setActiveKey}
                  billChargeInfo={billChargeInfo}
                />
              </TabPane>
              <TabPane
                disabled={status != "OK" && status !== "FN"}
                tab={"Payment Info"}
                key={"eInvoice-info"}
              >
                <TabEInvoice
                  billChargeInfo={billChargeInfo}
                  info={info}
                  status={status}
                  invoiceList={invoiceList}
                  paymentDetails={paymentDetails}
                  setActiveKey={setActiveKey}
                />
              </TabPane>
              <TabPane
                disabled={status != "OK" && status !== "FN"}
                tab={"Vehicle Registration"}
                key={"vehicle"}
              >
                <TabVehicle info={info} setActiveKey={setActiveKey} />
              </TabPane>
            </Tabs>
          </div>
        </div>
      </Skeleton>
    </>
  );
};
export default Checkout;
